$(function(){

	var buttonActiveClass = 'page-form-button-active';

	$('.page-form-button').on('click', function(){
		var self = $(this),
			targetId = self.data('page-form-target'),
			targetContainer = $('#page-form-container-' + targetId);
		$('.page-form-container').hide();
		$('.page-form-button').removeClass(buttonActiveClass);
		self.toggleClass(buttonActiveClass);
		targetContainer.slideToggle();
	});

	$('.FormBuilderErrors, .FormBuilderSubmitted, .alert-success').eq(0).each(function(){
		var self = $(this),
			container = self.closest('.page-form-container'),
			buttonId = container.data('page-form-button');
		$('#page-form-button-' + buttonId).addClass(buttonActiveClass);
		container.show();
	});

	$('.page-form-container #wrap_Inputfield_consent .InputfieldContent.form-check .form-text').on('click', function(){
		$(this).closest('#wrap_Inputfield_consent').find(':checkbox').click();
	});

	// quick and dirty
	$('.page-lang-de .page-form-container #wrap_Inputfield_consent .InputfieldContent.form-check .text-danger').text('Bitte stimmen Sie den Bedingungen zu.');
	$('.page-lang-en .page-form-container #wrap_Inputfield_consent .InputfieldContent.form-check .text-danger').text('Please agree to the terms and conditions.');

});